module.exports = function() {
  return new Worker(__webpack_public_path__ + "ea7e7d5bdfda8317e70d.worker.js");
};